/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../../components/Button';
import classes from './SlotFooter.module.css';

const buttonConfig = [
  { name: 'Notify', key: 'notify' },
  { name: 'Move', key: 'move' },
  { name: 'Clear', key: 'clear' },
  { name: 'Picked Up', key: 'pickedUp' },
];

const SlotFooter = ({ onSlotActionButtonPress, slot }) => {
  return (
    <div className={classes.footerContainer}>
      {buttonConfig.map(button =>
        <Button
          key={button.key}
          className={classes.actionButton}
          onClick={() => onSlotActionButtonPress(button.key, slot)}>
          <span className={classes.buttonText}>{button.name}</span>
        </Button>
      )}
    </div>
  );
};

export default SlotFooter;

SlotFooter.propTypes = {
  onSlotActionButtonPress: PropTypes.func,
  slot: PropTypes.object,
};

SlotFooter.defaultProps = {
  onSlotActionButtonPress: () => { },
  slot: {},
};
